<template>
  <div class="user_index">
    <div class="header">
      <hea-der></hea-der>
    </div>
    
    <router-view></router-view>
  </div>
</template>
<script>
import heaDer from "./../../src/components/user/header";
export default {
  components: {
    heaDer,
  },
  data() {
    return {
    };
  },
  mounted() {
    var _this = this;
  },
  methods: {
  }
};
</script>